import React from 'react'

type SVGProps = React.SVGProps<SVGSVGElement>

export function TwAlertTriangle(props: SVGProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.4716 5.28366C13.9774 2.46013 18.0245 2.46013 19.5304 5.28366L28.8637 22.7837C30.2847 25.4481 28.354 28.666 25.3343 28.666H6.66763C3.64795 28.666 1.7172 25.4481 3.13822 22.7837L12.4716 5.28366Z"
        className="fill-error-350"
      />
      <path
        d="M16 22.075C16.375 22.075 16.6254 22.1525 16.7754 22.3064C16.9252 22.4603 17 22.6658 17 22.8708V23.2039C17 23.409 16.9253 23.6144 16.7754 23.7683C16.6254 23.9222 16.375 23.9988 16 23.9988C15.625 23.9988 15.3746 23.9222 15.2246 23.7683C15.0747 23.6144 15 23.4346 15 23.2039V22.8708C15 22.6401 15.0748 22.4602 15.2246 22.3064C15.3996 22.1525 15.625 22.075 16 22.075ZM15.75 12.0203C16.7 11.8663 17.5 12.6104 17.5 13.5339V13.6619C17.325 15.1496 17.1754 16.6117 17.0254 18.0994L16.4502 20.6902C16.4002 20.8954 16.225 21.0496 16 21.0496C15.775 21.0496 15.5998 20.8957 15.5498 20.6648L14.9746 18.074C14.7996 16.5863 14.65 15.1242 14.5 13.6365C14.5 12.8669 15 12.1485 15.75 12.0203Z"
        className="fill-error-700"
      />
    </svg>
  )
}
